class VideoGallery {
    constructor(root) {
        this.root = root;
        this.buttons = Array.from(root.querySelectorAll('.product-video'));
        if (!this.buttons.length) return;

        this.lightbox = new PhotoSwipeLightbox({
            bgOpacity: 1,
            pswpModule: () => import(theme.settings.pswpModule),
            arrowPrevSVG: '   <svg class="pswp__icn icon" viewBox="0 0 37 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M10 5L3 11.9999M3 11.9999L10 18.9999M3 11.9999H33.5"></path></svg>',
            arrowNextSVG: '   <svg class="pswp__icn icon" viewBox="0 0 37 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M10 5L3 11.9999M3 11.9999L10 18.9999M3 11.9999H33.5"></path></svg>',
            closeSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
            allowPanToNext: false,
            allowMouseDrag: true,
            wheelToZoom: false,
            returnFocus: true,
            zoom: false
        });

        // Miniature PhotoSwipe
        this.lightbox.addFilter('thumbEl', (_thumbEl, data) => data.thumbnailElement);

        // Création du contenu vidéo
        this.lightbox.on('contentLoad', (event) => {
            const { content } = event;
            if (content.type !== 'video') return;

            event.preventDefault();

            const wrapper = document.createElement('div');
            wrapper.className = 'pswp__video-container';

            const videoEl = document.createElement('video');
            videoEl.src = content.data.videoSrc;
            videoEl.controls = true;
            videoEl.playsInline = true;
            videoEl.volume = 0.5;
            videoEl.preload = 'metadata';

            wrapper.appendChild(videoEl);
            content.element = wrapper;

            // Si c'est la slide active au moment où le contenu est prêt → lecture
            const pswp = this.lightbox.pswp;
            if (pswp && pswp.currSlide && pswp.currSlide === content.slide) {
                this.pauseAllVideos();
                this.playVideoInContainer(wrapper);
            }
        });

        // Quand une slide devient active → lire sa vidéo
        this.lightbox.on('contentActivate', (event) => {
            const { content } = event;
            if (content.type !== 'video' || !content.element) return;

            this.pauseAllVideos();
            this.playVideoInContainer(content.element);
        });

        // Quand une slide n'est plus active → pause
        this.lightbox.on('contentDeactivate', (event) => {
            const { content } = event;
            if (content.type !== 'video' || !content.element) return;
            this.pauseVideoInContainer(content.element);
        });

        this.lightbox.init();

        // Ouverture au clic sur la vignette
        this.buttons.forEach((btn, index) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(index);
            });
        });
    }

    buildDataSource() {
        return this.buttons.map((btn) => {
            const img = btn.querySelector('img');
            const aspectRatio = parseFloat(btn.dataset.aspectRatio || 0.5625); // 9/16 par défaut
            const videoSrc = btn.dataset.videoSrc;

            return {
                type: 'video',
                videoSrc,
                thumbnailElement: img,
                src: img ? img.src : '',
                msrc: img ? (img.currentSrc || img.src) : '',
                width: 800,
                height: 800 / aspectRatio,
                alt: img ? img.alt : '',
                thumbCropped: true
            };
        });
    }

    open(index = 0) {
        const dataSource = this.buildDataSource();
        this.lightbox.loadAndOpen(index, dataSource);
    }

    pauseAllVideos() {
        const pswp = this.lightbox.pswp;
        if (!pswp || !pswp.slides) return;

        pswp.slides.forEach((slide) => {
            if (!slide || !slide.content || !slide.content.element) return;
            this.pauseVideoInContainer(slide.content.element);
        });
    }

    pauseVideoInContainer(container) {
        if (!container) return;

        container.querySelectorAll('video').forEach((video) => {
            try {
                video.pause();
            } catch (e) {}
        });
    }

    playVideoInContainer(container) {
        if (!container) return;

        const video = container.querySelector('video');
        if (video) {
            video.play().catch(() => {});
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-videos').forEach((section) => {
        new VideoGallery(section);
    });
});
